import React from "react";
import Link from "next/link";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

import { BreadcrumbProps } from "./breadcrumb.types";

import s from "./breadcrumb.module.scss";

const Breadcrumb = ({
  items,
  icon = faChevronRight,
  iconProps,
  color = "link-turquoise"
}: BreadcrumbProps) => {
  return (
    <nav
      className="breadcrumb"
      aria-label="breadcrumb"
      role="navigation"
      style={{ height: "auto" }}
    >
      <ol className="breadcrumb-list">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {item.href ? (
              <li className="breadcrumb-item">
                <Link href={item.href} className={color}>
                  {item.label}
                </Link>
              </li>
            ) : (
              <li className={`breadcrumb-item ${color}`}>{item.label}</li>
            )}
            {index < items.length - 1 && icon && (
              <span
                className={`breadcrumb-separator ${s.breadcrumb_separator_icon}`}
                aria-hidden="true"
              >
                <FontAwesomeIcon icon={icon} {...iconProps} />
              </span>
            )}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
